import React from "react";
import ButtonWrapper from "../../pages/citizen/AVPForms/components/Button";
import { handleTabChange } from "../../pages/citizen/AVPForms/formComponents/land-Use/helpers/helpers";
import { useHistory } from "react-router-dom";

const LowRiskDisclaimer = ({ handleTabChange, tab, landArea }) => {
  const history = useHistory();
  const isEmployee = history.location.pathname.includes("employee");
  return (
    <React.Fragment>
      <div className="application-status-container">
        <p className="main-message">
          <strong>No NOC identification is required</strong> because application falls under the Low Risk Category.
        </p>
        <p className="conditions-heading">The conditions that categorize application as low risk are:</p>
        <ul className="conditions-list">
          <li>Application is under an Approved Scheme</li>
          <li>Land Use is Residential</li>
          {/* <li>Land Sub Use as per Layout is Residential</li> */}
          {/* {landArea ? <li>Your Land Area is: {landArea} which is below 2000m²</li> : <li>Land Area is 2000m² or less</li>}  */}
        </ul>
      </div>
      {!isEmployee && (
        <div className="footerContainer2">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="success"
              size="medium"
              label="Continue"
              type="submit"
              onClick={() => handleTabChange(tab)}
              sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default LowRiskDisclaimer;
